/**
 * @desc 自营整柜货订舱生成TMS
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(crno: string | number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/cabinMasterSelfWhole/createTmsForCabin/${crno}`, {
      method: "POST",

      ...options,
    }),
  );
}
